<template>
  <button
    class="app-btn"
    :class="{ 'disabled': disabled }"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'AppBtn',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.disabled || this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.app-btn {
  width: 6.5rem;
  height: 1rem;
  position: relative;
  bottom: 0;
  left: 0.5rem;
  z-index: 10;
  line-height: 1rem;
  text-align: center;
  font-size: $NFontSize;
  color: #fff;
  background-color: $theme;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0rem 0.05rem 0rem 0rem rgba(7, 43, 121, 0.3);

  &.disabled {
    background-color: $disabled;
    box-shadow: 0rem 0rem 0rem 0rem ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppTmpl/AppBtn.vue